import axios from 'axios';
import { headersProvider } from '../apiHelpers';
import constants from '../constants';

export const requestDemo = (data) => axios.post(`${constants.utilityHost}/book-demo/new`, data, {
  headers: headersProvider(),
});
